import React, { useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

// Images
import bgImage from "assets/images/bg-reset-cover.jpeg";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { useDispatch, useSelector } from "react-redux";
import { SendResetPasswordEmail } from "store/slice/usersSlice";
import Alert from "components/Alert/Alert"
import { useTranslation } from "react-i18next";
import { userActions } from "store/slice/usersSlice";

function ResetPassword() {

  const dispatch = useDispatch();
  const usersStore = useSelector(store=>store.user);

  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      dispatch(userActions.reset())
    }
  }, [])

  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  const handleSubmit = (values, { resetForm, setSubmitting }) => {

    dispatch(SendResetPasswordEmail(values.email)) .unwrap() 
    .then((result) => {
      resetForm();
    }).catch((error) => {
      setSubmitting(false)
    });;
  };

  return (
    <BasicLayout coverHeight="50vh" image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Reset Password
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            You will receive an e-mail in maximum 60 seconds
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          {usersStore.resetEmailError.status ? <Alert  message={t(usersStore.resetEmailError?.message)}  />: ''}
          {usersStore.resetEmailSuccess.status ? <Alert  message={t(usersStore.resetEmailSuccess?.message)} isSuccess={true} />: ''}
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, errors, touched }) => (
              <Form>
                <MDBox mb={4}>
                  <Field
                    name="email"
                    as={MDInput}
                    type="email"
                    label="Email"
                    variant="standard"
                    fullWidth
                    error={touched.email && Boolean(errors.email)}
                  />
                  <MDTypography
                    variant="caption"
                    color="error"
                    style={{ marginTop: "4px", display: "block" }}
                  >
                    <ErrorMessage name="email" />
                  </MDTypography>
                </MDBox>
                <MDBox mt={6} mb={1}>
                  <MDButton
                    variant="gradient"
                    color="info"
                    fullWidth
                    type="submit"
                    disabled={isSubmitting}
                  >
                    reset
                  </MDButton>
                </MDBox>
              </Form>
            )}
          </Formik>
          <MDBox mt={3} mb={1} textAlign="center">
            <MDTypography variant="button" color="text">
              Sign in?{" "}
              <MDTypography
                component={Link}
                to="/auth/login"
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient
              >
                Sign in
              </MDTypography>
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default ResetPassword;
